import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "action-bar" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Appeler ")
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Contact ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Rappel ")
const _hoisted_6 = { class: "action-bar-m" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Appeler ")
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Contact ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Rappel ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "action-spacer" }, " ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!this.store.state.phone_shown)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => {this.store.state.phone_shown = true; this.store.state.counter( 'contact', _ctx.gm.id, () => '' );})
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "phone" }),
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      (this.store.state.phone_shown)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: 'tel:'+this.store.state.gm.phone,
            class: "clicked"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "phone" }),
            _createTextVNode(" " + _toDisplayString(this.store.state.gm.phone), 1)
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => {this.store.state.contact_modal = true;})
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "envelope" }),
        _hoisted_4
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => {this.store.state.callback_modal = true;})
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "voicemail" }),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!this.store.state.phone_shown)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => {this.store.state.phone_shown = true; this.store.state.counter( 'contact', _ctx.gm.id, () => '' );})
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "phone" }),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (this.store.state.phone_shown)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: 'tel:'+this.store.state.gm.phone,
            class: "clicked"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "phone" }),
            _createTextVNode(" " + _toDisplayString(this.store.state.gm.phone), 1)
          ], 8, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => {this.store.state.contact_modal = true;})
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "envelope" }),
        _hoisted_9
      ]),
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => {this.store.state.callback_modal = true;})
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "voicemail" }),
        _hoisted_10
      ])
    ]),
    _hoisted_11
  ], 64))
}